import moment from 'moment';
import { MutationTree } from 'vuex';
import { ArchiveState } from '../stores/archive.store';
import { ITag } from '@/types/Tag';
import GroupFiltersEnum from '@/enums/GroupFilters';

export const mutationError = 'error';
export const mutationLoadingTeams = 'loadingTeams';
export const mutationSetTeams = 'setTeams';
export const mutationSetScopeFilter = 'setScopeFilter';
export const mutationSetEndDateFilter = 'setEndDateFilter';
export const mutationApplyEndDateFilter = 'applyEndDateFilter';
export const mutationSetTagFilter = 'setTagFilter';
export const mutationSetTags = 'setTags';
export const mutationLoadingTags = 'loadingTags';
export const mutationSetGroupFilter = 'setGroupFilter';

export const mutations: MutationTree<ArchiveState> = {
  [mutationError](state, error) {
    state.error = error;
  },
  [mutationLoadingTeams](state, payload) {
    state.isLoadingTeams = payload;
  },
  [mutationSetTeams](state, teams) {
    state.teams = teams;
    state.error = '';
    state.isLoadingTeams = false;
  },
  [mutationSetScopeFilter](state, users) {
    state.scopeFilter = {
      ...state.scopeFilter,
      users,
    };
  },
  [mutationSetEndDateFilter](state, { from, to, month }) {
    state.endDateFilter = {
      ...state.endDateFilter,
      from,
      to,
      month,
    };
  },
  [mutationApplyEndDateFilter](state) {
    const { month, from, to } = state.endDateFilter;
    let fromString = '';
    let toString = '';
    let range = '';

    if (month) {
      fromString = moment(month).format('YYYY-MM-DD');
      toString = moment(month).endOf('month').format('YYYY-MM-DD');
      range = `${fromString} - ${toString}`;
    } else if (from || to) {
      fromString = from ? moment(from).format('YYYY-MM-DD') : '';
      toString = to ? moment(to).format('YYYY-MM-DD') : '';
      range = `${fromString} - ${toString}`;
    }
    state.endDateFilter = {
      ...state.endDateFilter,
      range,
    };
  },
  [mutationSetTags](state, tags: ITag[]) {
    state.tags = tags;
  },
  [mutationSetTagFilter](state, tags: string[]) {
    state.tagFilter = tags.join(', ');
  },
  [mutationLoadingTags](state, payload: boolean) {
    state.isLoadingTags = payload;
  },
  [mutationSetGroupFilter](state, payload: GroupFiltersEnum) {
    state.groupFilter = payload;
  },
};
